export enum TaxRoundTypes {
  HalfUp = 0,
  Up = 1,
  Down = 2,
}

export function getTaxRoundTypeName(value: TaxRoundTypes): string {
  switch (value) {
    case TaxRoundTypes.HalfUp: return '四捨五入';
    case TaxRoundTypes.Up: return '切り上げ';
    case TaxRoundTypes.Down: return '切り捨て';
  }
}

export function getTaxRoundTypes(includeNone: boolean = true): TaxRoundTypes[] {
  const list: TaxRoundTypes[] = [];
  for (const item in TaxRoundTypes) {
    if (!isNaN(Number(item))) {
      const num = Number(item);
      list.push(num);
    }
  }
  return list;
}
